// Bildirilen çapalardan ŞU AN çözülebilenler — ve içerik geldikçe güncellenen.
//
// Kabuk turu da ekran turu da bunu kullanır. İkisine ayrı ayrı yazmak, aynı
// kusurun iki kez düzeltilmesi gereken iki kopyası demekti: kusur zaten İKİSİNDE
// DE vardı ve yalnız birinde fark edildi.
//
// ÖLÇÜLEN KUSUR. Her iki taraf da DOM'u bir kez okuyan bir `useMemo` idi.
// Çözümleme, kod-bölünmüş rota chunk'ı inmeden ya da React Query verisi
// gelmeden koşuyor ve bir daha hiç bakmıyordu; sonuç, /settings/roles,
// /settings, /support/tickets ve / ekranlarında "Bu ekranı tanıt" düğmesinin
// HİÇ çizilmemesiydi — çapalar DOM'da olmasına rağmen. Eager rotalar ve veriye
// bağlı olmayan çapalar yarışı kazandığı için belirti düzensiz görünüyordu ve
// iki kez "ölçüm aracının geçici okuması" diye yanlış teşhis edildi.

import { useEffect, useState } from "react";

import { resolveAnchor } from "./anchors";

function scopeRoot(scope: "main" | "document"): HTMLElement | null {
  return scope === "document" ? document.body : document.querySelector("main");
}

/**
 * @param declared manifest sırasındaki çapa id'leri; `null` = bu yüzeyin turu yok.
 *   Referansı kararlı olmalı (modül sabiti ya da manifest satırı) — her render'da
 *   yeni bir dizi vermek gözlemciyi sürekli kurup söker.
 * @param enabled `false` iken hiç ölçme: kapalı bir tur için subtree gözlemek
 *   bedava değil.
 */
export function useResolvableAnchors(
  declared: readonly string[] | null,
  scope: "main" | "document",
  enabled = true,
): readonly string[] {
  const [anchors, setAnchors] = useState<readonly string[]>([]);

  useEffect(() => {
    const root = declared === null || !enabled ? null : scopeRoot(scope);
    if (declared === null || root === null || !enabled) {
      setAnchors([]);
      return undefined;
    }

    // true = bildirilenlerin hepsi bulundu; izlemeye devam etmenin karşılığı yok.
    const measure = (): boolean => {
      const found = declared.filter((id) => resolveAnchor(id, root) !== null);
      // Eşit diziyi tekrar yazmak render → gözlem → render döngüsü kurardı.
      setAnchors((prev) =>
        prev.length === found.length && prev.every((v, i) => v === found[i]) ? prev : found,
      );
      return found.length === declared.length;
    };

    if (measure()) return undefined;
    if (typeof MutationObserver === "undefined") return undefined;
    const observer = new MutationObserver(() => {
      if (measure()) observer.disconnect();
    });
    observer.observe(root, { childList: true, subtree: true });
    return (): void => {
      observer.disconnect();
    };
  }, [declared, scope, enabled]);

  return anchors;
}
